var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackend3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 210H97.5L102.487 180H137.512L142.5 210Z",
    fill: "#074F77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.386 191.25H100.648L102.486 180H137.511L139.386 191.25Z",
    fill: "#00325A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.75 187.5H101.25L102.487 180H137.512L138.75 187.5Z",
    fill: "#00325A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225 52.5V180C225 184.125 221.625 187.5 217.5 187.5H22.5C18.375 187.5 15 184.125 15 180V52.5C15 48.375 18.375 45 22.5 45H217.5C221.625 45 225 48.375 225 52.5Z",
    fill: "#87C9E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 56.25V161.25C217.5 163.312 215.812 165 213.75 165H26.25C24.1875 165 22.5 163.312 22.5 161.25V56.25C22.5 54.1875 24.1875 52.5 26.25 52.5H213.75C215.812 52.5 217.5 54.1875 217.5 56.25Z",
    fill: "#FAB400"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.75 52.5C176.359 52.5 63.2775 52.5 26.25 52.5C24.1875 52.5 22.5 54.1875 22.5 56.25V60C22.5 57.9375 24.1875 56.25 26.25 56.25H37.5V146.25C37.5 148.312 39.1875 150 41.25 150H198.75C200.812 150 202.5 148.312 202.5 146.25V56.25H213.75C215.812 56.25 217.5 57.9375 217.5 60V56.25C217.5 54.1875 215.812 52.5 213.75 52.5Z",
    fill: "#DC9600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.5 18.75V37.5H37.5V18.75C37.5 16.6875 39.1875 15 41.25 15H198.75C200.812 15 202.5 16.6875 202.5 18.75Z",
    fill: "#2A4D68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.25 225H78.75C76.68 225 75 223.32 75 221.25V217.5C75 213.356 78.3562 210 82.5 210H157.5C161.644 210 165 213.356 165 217.5V221.25C165 223.32 163.32 225 161.25 225Z",
    fill: "#87C9E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.75 180H213.75C215.82 180 217.5 178.32 217.5 176.25C217.5 174.18 215.82 172.5 213.75 172.5H198.75C196.68 172.5 195 174.18 195 176.25C195 178.32 196.68 180 198.75 180Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.75 180C185.821 180 187.5 178.321 187.5 176.25C187.5 174.179 185.821 172.5 183.75 172.5C181.679 172.5 180 174.179 180 176.25C180 178.321 181.679 180 183.75 180Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.5 37.5V142.5C202.5 144.562 200.812 146.25 198.75 146.25H41.25C39.1875 146.25 37.5 144.562 37.5 142.5V37.5H202.5Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 56.25C121.8 56.25 105 61.275 105 67.5V127.5C105 133.725 121.8 138.75 142.5 138.75C163.2 138.75 180 133.725 180 127.5V67.5C180 61.275 163.2 56.25 142.5 56.25Z",
    fill: "#D2D2D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.25 30C193.321 30 195 28.3211 195 26.25C195 24.1789 193.321 22.5 191.25 22.5C189.179 22.5 187.5 24.1789 187.5 26.25C187.5 28.3211 189.179 30 191.25 30Z",
    fill: "#C80A50"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176.25 30C178.321 30 180 28.3211 180 26.25C180 24.1789 178.321 22.5 176.25 22.5C174.179 22.5 172.5 24.1789 172.5 26.25C172.5 28.3211 174.179 30 176.25 30Z",
    fill: "#87C9E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.25 30C163.321 30 165 28.3211 165 26.25C165 24.1789 163.321 22.5 161.25 22.5C159.179 22.5 157.5 24.1789 157.5 26.25C157.5 28.3211 159.179 30 161.25 30Z",
    fill: "#FAB400"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 37.5H82.5V146.25H37.5V37.5Z",
    fill: "#D2D2D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105 30H48.75C46.68 30 45 28.32 45 26.25C45 24.18 46.68 22.5 48.75 22.5H105C107.07 22.5 108.75 24.18 108.75 26.25C108.75 28.32 107.07 30 105 30Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 52.5C121.8 52.5 105 57.525 105 63.75V123.75C105 129.975 121.8 135 142.5 135C163.2 135 180 129.975 180 123.75V63.75C180 57.525 163.2 52.5 142.5 52.5Z",
    fill: "#FF6A55"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M180 93.75V108.75C180 114.975 163.2 120 142.5 120C121.8 120 105 114.975 105 108.75V93.75C105 99.975 121.8 105 142.5 105C163.2 105 180 99.975 180 93.75Z",
    fill: "#BC220D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180 63.75V78.75C180 84.975 163.2 90 142.5 90C121.8 90 105 84.975 105 78.75V63.75C105 69.975 121.8 75 142.5 75C163.2 75 180 69.975 180 63.75Z",
    fill: "#BC220D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 56.25H48.75C46.68 56.25 45 54.57 45 52.5C45 50.43 46.68 48.75 48.75 48.75H71.25C73.32 48.75 75 50.43 75 52.5C75 54.57 73.32 56.25 71.25 56.25Z",
    fill: "#00325A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 71.25H48.75C46.68 71.25 45 69.57 45 67.5C45 65.43 46.68 63.75 48.75 63.75H71.25C73.32 63.75 75 65.43 75 67.5C75 69.57 73.32 71.25 71.25 71.25Z",
    fill: "#00325A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 86.25H48.75C46.68 86.25 45 84.57 45 82.5C45 80.43 46.68 78.75 48.75 78.75H71.25C73.32 78.75 75 80.43 75 82.5C75 84.57 73.32 86.25 71.25 86.25Z",
    fill: "#00325A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 101.25H48.75C46.68 101.25 45 99.57 45 97.5C45 95.43 46.68 93.75 48.75 93.75H71.25C73.32 93.75 75 95.43 75 97.5C75 99.57 73.32 101.25 71.25 101.25Z",
    fill: "#00325A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 116.25H48.75C46.68 116.25 45 114.57 45 112.5C45 110.43 46.68 108.75 48.75 108.75H71.25C73.32 108.75 75 110.43 75 112.5C75 114.57 73.32 116.25 71.25 116.25Z",
    fill: "#00325A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 131.25H48.75C46.68 131.25 45 129.57 45 127.5C45 125.43 46.68 123.75 48.75 123.75H71.25C73.32 123.75 75 125.43 75 127.5C75 129.57 73.32 131.25 71.25 131.25Z",
    fill: "#00325A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend3);
export default __webpack_public_path__ + "static/media/backend 3.5c1092e0319c1d625d5f1a11a0e11fc4.svg";
export { ForwardRef as ReactComponent };